import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const useUserPresencial = create(persist(
    (set) => ({
    userPresencial: {
        dni: '',
    },
    updateUserPresencial: (newUser) => set(() => ({ userPresencial: newUser })),
    closeUserPresencial: () => set(() => ({ userPresencial: { dni: ''} })),
}), {name: 'userPresencial', storage: createJSONStorage(() => sessionStorage) }
))